<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Ratings</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (unitTypeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Unit Type:</label>
            <select class="halfWidthInputField" #unitTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(unitTypeSelection.Name)"
              (change)="unitChanged(unitTypeSelection, unitTypeInput.value)"
              [value]="unitTypeSelection.Value.toString()">
              @for (allowable of unitTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="unitTypeSelection.Value && unitTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (unitSizeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Size:</label>
            <select class="halfWidthInputField" #unitSizeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(unitSizeSelection.Name)"
              (change)="selectionChanged(unitSizeSelection, unitSizeInput.value)"
              [value]="unitSizeSelection.Value.toString()">
              @for (allowable of unitSizeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="unitSizeSelection.Value && unitSizeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (systemTypeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">System Type:</label>
            <select class="halfWidthInputField" #systemTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(systemTypeSelection.Name)"
              (change)="systemChanged(systemTypeSelection, systemTypeInput.value)"
              [value]="systemTypeSelection.Value.toString()">
              @for (allowable of systemTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="systemTypeSelection.Value && systemTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (coilRowsSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Coil Rows:</label>
            <select class="halfWidthInputField" #coilRowsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(coilRowsSelection.Name)"
              (change)="selectionChanged(coilRowsSelection, coilRowsInput.value)"
              [value]="coilRowsSelection.Value.toString()">
              @for (allowable of coilRowsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="coilRowsSelection.Value && coilRowsSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (unitVoltageSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Unit Voltage:</label>
            <select class="halfWidthInputField" #unitVoltageInput
              [class.invalidConfigurationSelection]="isInvalidSelection(unitVoltageSelection.Name)"
              (change)="selectionChanged(unitVoltageSelection, unitVoltageInput.value)"
              [value]="unitVoltageSelection.Value.toString()">
              @for (allowable of unitVoltageSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="unitVoltageSelection.Value && unitVoltageSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (motorTypeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Motor Type:</label>
            <select class="halfWidthInputField" #motorTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(motorTypeSelection.Name)"
              (change)="selectionChanged(motorTypeSelection, motorTypeInput.value)"
              [value]="motorTypeSelection.Value.toString()">
              @for (allowable of motorTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="motorTypeSelection.Value && motorTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
    </div>
  }
</div>
